module.exports = __webpack_public_path__ + "img/160.08600128.jpg";